// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mat-mdc-cell {
  color: dimgray !important;
}

.main-col {
  color: black !important;
  font-weight: bolder;
}

.mat-mdc-paginator, .mat-mdc-paginator-page-size .mat-mdc-select-trigger {
  color: rgba(0, 0, 0, 0.54);
}

.mat-mdc-paginator::ng-deep .mdc-text-field::ng-deep .mdc-notched-outline__trailing,
.mat-mdc-paginator::ng-deep .mdc-text-field::ng-deep .mdc-notched-outline__notch,
.mat-mdc-paginator::ng-deep .mdc-text-field::ng-deep .mdc-notched-outline__leading {
  border: none !important;
}

.top-actions {
  position: absolute;
  right: 7px;
  top: 29px;
  display: flex;
}
.top-actions mat-icon {
  color: rgba(0, 0, 0, 0.26);
}
.top-actions .columns-visibility-menu {
  margin-right: 13px;
}
.top-actions .top-menu {
  margin-right: 13px;
}

.std-table-container {
  background-color: white;
  min-height: 200px;
  margin-top: 0px;
}
.std-table-container .std-table-table-container {
  position: relative;
  height: calc(100vh - 198px);
  overflow: auto;
}
.std-table-container .std-table-table-container .std-table-table.resizing {
  -webkit-user-select: none;
          user-select: none;
  cursor: col-resize;
}
.std-table-container .std-table-loading-shade {
  background: transparent !important;
  display: flex;
  justify-content: center;
  align-items: center;
}

table::ng-deep {
  width: 100%;
  table-layout: fixed;
}
table::ng-deep .mat-mdc-header-cell {
  position: relative;
}
table::ng-deep .resize-holder {
  cursor: col-resize;
  width: 20px;
  height: 100%;
  position: absolute;
  right: -10px;
  top: 0;
  z-index: 1;
}
table::ng-deep .column-icon {
  vertical-align: middle;
}
table::ng-deep .mat-sort-header-content {
  line-height: initial;
}

th, td {
  padding-right: 20px !important;
  padding-left: 0px;
}
th.expanded-icon, td.expanded-icon {
  padding-left: 10px !important;
  padding-right: 30px !important;
}
th.pointer-events-none, td.pointer-events-none {
  pointer-events: none;
}

th:first-of-type, td:first-of-type, td:first-of-type {
  padding-left: 24px;
}

td {
  font-family: Quicksand Light;
}
td.number-type {
  text-align: right;
}
td.string-type {
  text-align: left;
}
td.html-type {
  text-align: left;
}
td.boolean-type {
  text-align: center;
}
td.date-type {
  text-transform: capitalize;
  text-align: left;
}
td.budget_md-type, td.budget_md_with_null-type {
  text-align: right;
}
td.budget_pct-type, td.budget_pct_with_null-type {
  text-align: right;
}

.td-icon mat-icon {
  font-size: 14px;
  float: right;
  padding-top: 3px;
}

.table-filter {
  padding-left: 25px;
  padding-right: 25px;
}
.table-filter .filter-field {
  max-width: 400px;
}
.table-filter .filter-field mat-label {
  font-size: 14px;
}
.table-filter .filter-field mat-form-field {
  width: 100%;
}

.fab-add {
  position: absolute;
  z-index: 103;
  right: -4px;
  width: 45px;
  height: 46px;
  top: -25px;
}

.actions-col::ng-deep {
  padding-right: 0px !important;
  text-align: center;
}
.actions-col::ng-deep .mat-mdc-unelevated-button,
.actions-col::ng-deep .mat-mdc-unelevated-button:hover {
  --mdc-filled-button-container-color: transparent!important;
}

::ng-deep.cdk-overlay-pane {
  min-width: 100px;
}

.filters-th .filters-th-cont input, .filters-th .filters-th-cont mat-select::ng-deep {
  border: 1px solid rgba(0, 0, 0, 0.12);
  height: 30px;
}
.filters-th .filters-th-cont input .mat-mdc-select-value, .filters-th .filters-th-cont mat-select::ng-deep .mat-mdc-select-value {
  height: 30px;
  vertical-align: middle;
}
.filters-th .filters-th-cont .mat-mdc-input-element {
  width: 100%;
}
.filters-th .filters-th-cont .reset-filter-icon {
  color: rgba(0, 0, 0, 0.26);
}
.filters-th .filters-th-cont:focus {
  outline: none;
}
.filters-th .filters-th-cont .mat-mdc-input-element:focus {
  outline: none;
}
.filters-th.cdk-column-actions_filter input {
  width: 45px;
}

tr.detail-row {
  height: 0;
  padding-top: 5px;
  padding-bottom: 5px;
}

tr.element-row:not(.example-expanded-row):hover {
  background: whitesmoke;
}

tr.element-row:not(.example-expanded-row):active {
  background: #efefef;
}

.element-row td {
  border-bottom-width: 0;
}

.element-detail::ng-deep {
  overflow: hidden;
  max-width: 1500px;
}
.element-detail::ng-deep .expanded-content {
  padding: 10px 15px 10px 15px;
}
.element-detail::ng-deep .expanded-content .no-content {
  display: none;
}
.element-detail::ng-deep .expanded-content .with-content {
  display: initial;
}

.button-icon-only {
  text-align: center;
}
.button-icon-only mat-icon {
  margin-right: 0px;
}

.table-top-section {
  background: white;
  display: flex;
  align-items: center;
  padding-top: 20px;
}

::ng-deep.mat-mdc-menu-panel.columns-visibility {
  max-height: 500px;
}
::ng-deep.mat-mdc-menu-panel.columns-visibility .search-columns {
  width: auto;
  padding: 8px 16px 0;
}
::ng-deep.mat-mdc-menu-panel.columns-visibility .search-columns .mat-mdc-form-field {
  width: 100%;
}
::ng-deep.mat-mdc-menu-panel.columns-visibility .search-columns .mat-mdc-form-field mat-icon {
  color: #ed6b75;
}

mat-spinner {
  top: 45px;
}

.disabled-element span * {
  opacity: 0.6;
}

.table-top-section,
.table-bottom-section {
  padding-right: 105px;
}

.text-center {
  text-align: center !important;
}

mat-icon.tooltip {
  vertical-align: sub;
  font-size: medium;
}

::ng-deep .mat-mdc-tooltip {
  color: white;
  background-color: #0175c0;
  font-size: 12px;
}

.expand-icon {
  vertical-align: middle;
  font-size: 18px;
  height: 18px;
  width: 18px;
  color: #9d9d9d;
  margin-bottom: 2px;
}

.editable-field {
  width: 100%;
}

.editable-field-container {
  padding-left: 24px;
}

.mdc-data-table__header-cell {
  color: rgba(0, 0, 0, 0.54);
  font-size: 12px !important;
}`, "",{"version":3,"sources":["webpack://./src/theme/theme.scss","webpack://./src/app/components/tables/table/table.component.scss"],"names":[],"mappings":"AA0EA;EACE,yBAAA;ACzEF;;AD2EA;EACE,uBAAA;EACA,mBAAA;ACxEF;;AD2EA;EACE,0BAAA;ACxEF;;AD6EM;;;EAII,uBAAA;AC3EV;;AAfA;EACI,kBAAA;EACA,UAAA;EACA,SAAA;EACA,aAAA;AAkBJ;AAjBI;EACI,0BAAA;AAmBR;AAjBI;EACI,kBAAA;AAmBR;AAjBI;EACI,kBAAA;AAmBR;;AAfA;EACI,uBAAA;EACA,iBAAA;EACA,eAAA;AAkBJ;AAjBI;EACI,kBAAA;EAGA,2BAAA;EACA,cAAA;AAiBR;AAdY;EAGI,yBAAA;UAAA,iBAAA;EACA,kBAAA;AAgBhB;AAXI;EACI,kCAAA;EACA,aAAA;EAAe,uBAAA;EAAyB,mBAAA;AAehD;;AAZA;EACI,WAAA;EACA,mBAAA;AAeJ;AAbI;EACI,kBAAA;AAeR;AAZI;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,MAAA;EACA,UAAA;AAcR;AAXI;EACI,sBAAA;AAaR;AAVI;EACI,oBAAA;AAYR;;AARA;EACI,8BAAA;EACA,iBAAA;AAWJ;AAVI;EACI,6BAAA;EACA,8BAAA;AAYR;AAVI;EACI,oBAAA;AAYR;;AARA;EACI,kBAAA;AAWJ;;AARA;EACI,4BAAA;AAWJ;AATI;EACI,iBAAA;AAWR;AARI;EACI,gBAAA;AAUR;AAPI;EACI,gBAAA;AASR;AANI;EACI,kBAAA;AAQR;AALI;EACI,0BAAA;EACA,gBAAA;AAOR;AALI;EAEI,iBAAA;AAMR;AAJI;EAEI,iBAAA;AAKR;;AAAI;EACI,eAAA;EACA,YAAA;EACA,gBAAA;AAGR;;AACA;EACI,kBAAA;EACA,mBAAA;AAEJ;AADI;EACI,gBAAA;AAGR;AAFQ;EACI,eAAA;AAIZ;AAFQ;EACI,WAAA;AAIZ;;AACA;EACI,kBAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;AAEJ;;AAMA;EACI,6BAAA;EACA,kBAAA;AAHJ;AAKI;;EAEI,0DAAA;AAHR;;AAMA;EACQ,gBAAA;AAHR;;AASQ;EACI,qCAAA;EACA,YAAA;AANZ;AASY;EACI,YAAA;EACA,sBAAA;AAPhB;AAaQ;EACI,WAAA;AAXZ;AAcQ;EACI,0BAAA;AAZZ;AAeQ;EACI,aAAA;AAbZ;AAeQ;EACI,aAAA;AAbZ;AAiBQ;EACI,WAAA;AAfZ;;AAqBA;EACI,SAAA;EACA,gBAAA;EACA,mBAAA;AAlBJ;;AAqBA;EACI,sBAAA;AAlBJ;;AAqBA;EACI,mBAAA;AAlBJ;;AAqBA;EACI,sBAAA;AAlBJ;;AAqBA;EACI,gBAAA;EACA,iBAAA;AAlBJ;AAmBI;EACI,4BAAA;AAjBR;AAmBQ;EACI,aAAA;AAjBZ;AAmBQ;EACI,gBAAA;AAjBZ;;AAsBA;EACI,kBAAA;AAnBJ;AAoBI;EACI,iBAAA;AAlBR;;AAsBA;EACI,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;AAnBJ;;AAsBA;EACI,iBAAA;AAnBJ;AAoBI;EACI,WAAA;EACA,mBAAA;AAlBR;AAmBQ;EACI,WAAA;AAjBZ;AAkBY;EACI,cDxIL;ACwHX;;AAsBA;EACI,SAAA;AAnBJ;;AAuBI;EACI,YAAA;AApBR;;AAwBA;;EAEI,oBAAA;AArBJ;;AAwBA;EACI,6BAAA;AArBJ;;AAwBA;EACI,mBAAA;EACA,iBAAA;AArBJ;;AAuBA;EACI,YAAA;EACA,yBDpMe;ECqMf,eAAA;AApBJ;;AAuBA;EACI,sBAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;AApBJ;;AAuBA;EACI,WAAA;AApBJ;;AAuBA;EACI,kBAAA;AApBJ;;AAuBA;EACI,0BAAA;EACA,0BAAA;AApBJ","sourcesContent":["@use '@angular/material' as mat;\n// theme.scss\n\n$my-app: (\n  10:  #e8fafb2e,\n  50:  #32c5d22e,\n  100: #32c5d23d,\n  200: orange,\n  300: #32c5d25c,\n  400: #8cdce4,\n  500: #32c5d2c2,\n  600: #32c5d2,\n  700: #1f858e,\n  800: #18666d,\n  900: #337ab7,\n  A100: #ffffff,\n  A200: #def6f8,\n  A400: #a1f3fb,\n  A700: #7aecf7,\n  contrast: (\n    50 : #32c5d25c,\n    100 : #32c5d2c2,\n    200 : white,\n    300 : #1f858e,\n    400 : #18666d,\n    500 : #337ab7,\n    600 : #ffffff,\n    700 : #ffffff,\n    800 : #ffffff,\n    900 : #ffffff,\n    A100 : #32c5d2,\n    A200 : #1f858e,\n    A400 : #18666d,\n    A700 : #337ab7,\n  ));\n\n$my-app-primary: mat.m2-define-palette($my-app, 600);\n$my-app-accent : mat.m2-define-palette($my-app, 900);\n$my-app-warn : mat.m2-define-palette($my-app, 200);\n$my-app-sidebar : mat.m2-define-palette($my-app, 10);\n$my-app-background : mat.m2-define-palette($my-app, 50);\n$my-app-colored-card : mat.m2-define-palette($my-app, 100);\n$my-app-light : mat.m2-define-palette($my-app, 200);\n\n\n$comv-typography-config: mat.m2-define-typography-config(\n\n  $body-1: mat.m2-define-typography-level(14px, 21px, 400) \n  // ...\n);\n\n$my-theme: mat.m2-define-light-theme((\n  color: (\n    primary: $my-app-primary,\n    accent: $my-app-accent,\n    warn: $my-app-warn\n  ),\n  typography: $comv-typography-config,\n  density: 0,\n));\n\n$comv-dark-blue: #26344B;\n$comv-middle-blue: #337ab7;\n$comv-primary-blue: #32c5d2;\n$comv-light-blue1: #EDF9FD;\n$comv-light-blue2: #D7F3FB;\n$comv-red: #ed6b75;\n$comv-light-gray: #f1f1f1;\n$comv-tab1: #0175c0;\n$comv-tab2: #009BC6;\n$comv-ultralight-gray: rgba(242, 242, 242, 0.15); \n$comv-table-header-border: #a8b7c1;\n\n\n.mat-mdc-cell {\n  color:dimgray !important;\n}\n.main-col {\n  color: black !important;\n  font-weight: bolder;\n}\n\n.mat-mdc-paginator, .mat-mdc-paginator-page-size .mat-mdc-select-trigger {\n  color: rgba(0, 0, 0, 0.54);\n}\n\n.mat-mdc-paginator::ng-deep {\n  .mdc-text-field::ng-deep {\n      .mdc-notched-outline__trailing,\n      .mdc-notched-outline__notch,\n      .mdc-notched-outline__leading\n       {\n          border: none !important;\n      }\n  }\n}\n\n$comv-blue-dark :#04488f;\n$comv-blue-medium :#0175c0;\n$comv-blue-light :#00b0e1;\n$comv-gray-medium :#8f8f8f;\n$comv-yellow-light :#ecb842;\n$comv-yellow-dark :#e6a540;\n$comv-pink-light :#aa488d;\n$comv-pink-dark :#7d478e;\n$comv-green-light :#8db854;\n$comv-green-dark :#54763f;\n\n\n//$comv-dark-blue: #26344B;\n// $comv-dark-blue : $comv-blue-dark;\n\n//$comv-middle-blue: #337ab7;\n$comv-middle-blue: $comv-blue-medium;\n//$comv-primary-blue: #28b5b9;  \n$comv-primary-blue: $comv-blue-light;\n\n$comv-primary-blue-hover: #32c5d2;  \n\n//$comv-accent-blue: #0065AF;\n$comv-accent-blue: $comv-blue-medium;\n$comv-accent-blue-hover: #0075C9;\n$comv-light-blue1: #EDF9FD;\n$comv-light-blue2: #D7F3FB;\n$comv-light-blue3: #009BC6; \n$comv-light-blue3-hover: #00b3e3;\n\n$comv-red: #ed6b75;\n$comv-light-gray: #f1f1f1;\n$comv-tab-icon:$comv-middle-blue;\n$comv-tab-icon-hover:$comv-primary-blue;\n\n$comv-grid-highlight: #f6f6f6;\n$comv-grid-hover: #D7F3FB;\n\n$comv-chips-color: $comv-light-gray;\n\n$comv-admo-matched: greenyellow;\n$comv-admo-disabled: lightgray;\n$comv-admo-validated: green;\n$comv-admo-published: $comv-primary-blue;\n$comv-admo-split: #7e478e87;\n$comv-admo-merge: #ffa500;","@import \"../../../../theme/theme.scss\";\n\n.top-actions {\n    position: absolute;\n    right: 7px;\n    top: 29px;\n    display: flex;\n    mat-icon {\n        color: rgba(0, 0, 0, 0.26);\n    }\n    .columns-visibility-menu {\n        margin-right: 13px;\n    }\n    .top-menu {\n        margin-right: 13px;\n    }\n}\n// table style\n.std-table-container{\n    background-color: white;\n    min-height: 200px;\n    margin-top: 0px; //@margintable\n    .std-table-table-container{\n        position: relative;\n        // min-height: 350px;\n        // max-height: calc(100vh - 320px);\n        height: calc(100vh - 198px);\n        overflow: auto;\n\n        .std-table-table {\n            &.resizing {\n                -moz-user-select: none;\n                -ms-user-select: none;\n                user-select: none;\n                cursor: col-resize;\n            }\n        }\n    }\n\n    .std-table-loading-shade {\n        background: transparent!important;\n        display: flex; justify-content: center; align-items: center\n    }\n}\ntable::ng-deep {\n    width: 100%;\n    table-layout: fixed;\n\n    .mat-mdc-header-cell {\n        position: relative;   \n    }\n\n    .resize-holder {\n        cursor: col-resize;\n        width: 20px;\n        height: 100%;\n        position: absolute;\n        right: -10px;\n        top: 0;\n        z-index: 1;\n    }\n   \n    .column-icon {\n        vertical-align: middle;\n    }\n\n    .mat-sort-header-content {\n        line-height: initial;\n    }\n}\n\nth, td {\n    padding-right: 20px!important;\n    padding-left: 0px;\n    &.expanded-icon{\n        padding-left: 10px!important;\n        padding-right: 30px!important;\n    }\n    &.pointer-events-none {\n        pointer-events: none;\n    }\n}\n\nth:first-of-type, td:first-of-type, td:first-of-type {\n    padding-left: 24px;\n}\n\ntd {\n    font-family: Quicksand Light;\n\n    &.number-type {\n        text-align: right;\n    }\n\n    &.string-type {\n        text-align: left;\n    }\n\n    &.html-type {\n        text-align: left;\n    }\n\n    &.boolean-type {\n        text-align: center;\n    }\n\n    &.date-type {\n        text-transform: capitalize;\n        text-align: left;\n    }\n    &.budget_md-type,\n    &.budget_md_with_null-type {\n        text-align: right;\n    }\n    &.budget_pct-type,\n    &.budget_pct_with_null-type {\n        text-align: right;\n    }\n}\n\n.td-icon {\n    mat-icon {\n        font-size: 14px;\n        float: right;\n        padding-top: 3px;\n    }\n}\n\n.table-filter {\n    padding-left: 25px;\n    padding-right: 25px;\n    .filter-field {\n        max-width: 400px;\n        mat-label {\n            font-size: 14px;;\n        }\n        mat-form-field {\n            width: 100%;\n        }\n    }\n}\n\n.fab-add{\n    position: absolute;\n    z-index: 103;\n    right: -4px;\n    width: 45px;\n    height: 46px;\n    top: -25px;\n}\n\n// ::ng-deep .mat-sort-header-container:not(.mat-sort-header-sorted) .mat-sort-header-arrow {\n//     opacity: 0.54 !important;\n//     // transform: translateY(0px) !important;\n// }\n\n.actions-col::ng-deep {\n    padding-right: 0px!important;\n    text-align: center;\n\n    .mat-mdc-unelevated-button,\n    .mat-mdc-unelevated-button:hover {\n        --mdc-filled-button-container-color: transparent!important;\n    }\n}\n::ng-deep.cdk-overlay-pane{\n        min-width:100px;\n}\n\n\n.filters-th {\n    .filters-th-cont {\n        input, mat-select::ng-deep {\n            border: 1px solid rgba(0, 0, 0, 0.12);\n            height: 30px;\n            \n\n            .mat-mdc-select-value {\n                height: 30px;\n                vertical-align: middle;\n                \n            }\n\n\n        }\n        .mat-mdc-input-element {\n            width: 100%;\n        }\n\n        .reset-filter-icon {\n            color: rgba(0, 0, 0, 0.26);\n        }\n\n        &:focus {\n            outline:none;\n        }\n        .mat-mdc-input-element:focus {\n            outline:none;\n        }\n    }\n    &.cdk-column-actions_filter{\n        input {\n            width: 45px;\n        }\n    }\n}\n\n\ntr.detail-row {\n    height: 0;\n    padding-top: 5px;\n    padding-bottom: 5px;\n}\n  \ntr.element-row:not(.example-expanded-row):hover {\n    background: whitesmoke;\n}\n\ntr.element-row:not(.example-expanded-row):active {\n    background: #efefef;\n}\n\n.element-row td {\n    border-bottom-width: 0;\n}\n\n.element-detail::ng-deep {\n    overflow: hidden;\n    max-width: 1500px;\n    .expanded-content {\n        padding: 10px 15px 10px 15px;\n        \n        .no-content {\n            display: none;\n        }\n        .with-content {\n            display: initial;\n        }\n    }\n}\n\n.button-icon-only {\n    text-align: center;\n    mat-icon {\n        margin-right: 0px;\n    }\n}\n\n.table-top-section {\n    background: white;\n    display: flex;\n    align-items: center;\n    padding-top: 20px;\n}\n\n::ng-deep.mat-mdc-menu-panel.columns-visibility {\n    max-height: 500px;\n    & .search-columns{\n        width: auto;\n        padding: 8px 16px 0;\n        & .mat-mdc-form-field{\n            width: 100%;\n            & mat-icon{\n                color: $comv-red;\n            }\n        }\n    }\n}\n\nmat-spinner {\n    top: 45px;\n}\n\n.disabled-element {\n    span *{\n        opacity: 0.6;\n    }\n}\n\n.table-top-section, \n.table-bottom-section{\n    padding-right: 105px;\n}\n\n.text-center {\n    text-align: center!important;\n}\n\nmat-icon.tooltip {\n    vertical-align: sub;\n    font-size: medium;   \n}\n::ng-deep .mat-mdc-tooltip {\n    color: white;\n    background-color: $comv-middle-blue;\n    font-size: 12px;\n}\n\n.expand-icon {\n    vertical-align: middle;\n    font-size: 18px;\n    height: 18px;\n    width: 18px;\n    color: #9d9d9d;\n    margin-bottom: 2px;\n}\n\n.editable-field {\n    width: 100%;\n}\n\n.editable-field-container {\n    padding-left: 24px;\n}\n\n.mdc-data-table__header-cell {\n    color: rgba(0, 0, 0, 0.54);\n    font-size: 12px!important;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
